import * as styles from "./SectionLargeFeaturedPromo.module.scss";

import React from "react";
import StaticImageLibrary from "../../../components/StaticImageLibrary/StaticImageLibrary";
import { Button } from "../../../components/common";
import WrappedSection from "../../WrappedSection/WrappedSection";

export interface LargeFeaturedPromoProps {
	ctaOne?: { label: string; url: string };
	ctaTwo?: { label: string; url: string };
	titleLineOne: string;
	titleLineTwo: string;
	titleLineThree: string;
	description: string;
	imageTerm?: string;
	jumpLinksTitle?: string;
}

export const getSectionLargeFeaturedPromoProps = (
	data?: Queries.SectionDataFragment,
): LargeFeaturedPromoProps => ({
	...JSON.parse(data.field_json_config),
	imageTerm: data.relationships.field_large_featured_promo_image.name,
	jumpLinksTitle: data.field_jump_links_title,
});

export const SectionLargeFeaturedPromo: React.FC<LargeFeaturedPromoProps> = ({
	ctaOne,
	ctaTwo,
	titleLineOne,
	titleLineTwo,
	titleLineThree,
	description,
	imageTerm,
	jumpLinksTitle,
}) => {
	return (
		<WrappedSection sectionName={"SectionLargeFeaturedPromo"}>
			<div className={styles.largefeaturedpromo}>
				<div className={styles.imagecontainer}>
					<StaticImageLibrary
						className={styles.styledimage}
						imageName={imageTerm}
					/>
				</div>
				<div className={styles.content}>
					{jumpLinksTitle ? (
						<h2 className={styles.title} data-jumplinkstitle={jumpLinksTitle}>
							{titleLineOne}
							<span className={styles.highlight}>{titleLineTwo}</span>
							<span>{titleLineThree}</span>
						</h2>
					) : (
						<h2 className={styles.title}>
							{titleLineOne}
							<span className={styles.highlight}>{titleLineTwo}</span>
							<span>{titleLineThree}</span>
						</h2>
					)}
					<p>{description}</p>

					<div className={styles.buttoncontainer}>
						{ctaOne && (
							<Button variant={"secondary"} url={ctaOne.url} fullWidth={true}>
								{ctaOne.label}
							</Button>
						)}
						{ctaTwo && (
							<Button variant={"tertiary"} url={ctaTwo.url} fullWidth={true}>
								{ctaTwo.label}
							</Button>
						)}
					</div>
				</div>
			</div>
		</WrappedSection>
	);
};

export default SectionLargeFeaturedPromo;
